import api from "../../../services/api";

const APIS = {
    GET_PRODUCT_TYPES: "/ProductTypes",
    GET_ANALYST_DASHBOARD: "/AnalystDashboard/analyst-dashboard"
};

export const getProductTypes = async () => {
    try {
        const res = await api.get(APIS.GET_PRODUCT_TYPES);
        return {
            results: Array.isArray(res.data) ? res.data : [],
            success: true
        };
    } catch (error) {
        console.error("Get product types error:", error);
        return { results: [], success: false };
    }
};

const formatDateForAPI = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
};

const formatDateForDisplay = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
};

const mapProductTrends = (productTrends) => {
    return productTrends.map(trend => ({
        date: trend.date,
        productTypeCounts: trend.productCounts || {}
    }));
};

const mapSpeciesTrends = (speciesTrends) => {
    return speciesTrends.map(trend => ({
        species: trend.species,
        sampleCount: trend.total || 0,
        productCounts: trend.productCounts || {}
    }));
};

const mapPeerReviewData = (peerReviewSamples) => {
    return peerReviewSamples.map(sample => ({
        "SampleID": sample.sampleId || '',
        "Product": sample.product || '',
        "Company": sample.company || '',
        "Date": sample.date ? formatDateForDisplay(sample.date) : '',
        "Unit": sample.unit || '',
        "ExpLevel": sample.expLevel || '',
        "LowLimit": sample.lowLimit || '',
        "UpLimit": sample.upLimit || '',
        "Assay": sample.assay || '',
        "Assayby": sample.assayBy || '',
        "Re-Assay1": sample.reAssay1 || '',
        "Re-Assay1by": sample.reAssay1By || '',
        "Re-Assay2": sample.reAssay2 || '',
        "Re-Assay2by": sample.reAssay2By || '',
        "Result": sample.result || ''
    }));
};

export const getDashboardData = async (filters) => {
    try {
        const params = {
            from: formatDateForAPI(filters.fromDate),
            to: formatDateForAPI(filters.toDate)
        };
        if (filters.productType && filters.productType !== '' && parseInt(filters.productType) !== 0) {
            params.productTypeId = filters.productType;
        }
        const res = await api.get(APIS.GET_ANALYST_DASHBOARD, { params });
        const mappedData = {
            labProductTrend: {
                labTrends: mapProductTrends(res.data.productTrends || [])
            },
            labSpeciesTrend: mapSpeciesTrends(res.data.speciesTrends || []),
            peerReviewData: mapPeerReviewData(res.data.peerReviewSamples || [])
        };
        return {
            ...mappedData,
            success: true
        };
    } catch (error) {
        console.error("Get dashboard data error:", error);
        return {
            labProductTrend: { labTrends: [] },
            labSpeciesTrend: [],
            peerReviewData: [],
            success: false
        };
    }
};
